import { React, useState, useEffect } from "react";
import { Button, Form, Input, Radio, Checkbox } from "antd";
import { AlignCenterOutlined, WindowsOutlined } from "@ant-design/icons";
import IntlMessages from "util/IntlMessages";
import { useAuth } from "../authentication";
import AppNotificationContainer from "../components/AppNotificationContainer";
import logo from "../assets/images/logo.png";
import Logo from "../assets/images/LOGO_SIES_170_x_115_px.png";
import svgMicrosoft from "../assets/images/Microsoft_logo.svg";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import {
  loginRequest,
  setClientId,
  setRedirectUri,
  setTenant,
} from "./AzureLogin/authConfig";
import { callMsGraph } from "./AzureLogin/graph";
import { useHistory } from "react-router-dom";
import { generateToken, getAuthUser } from "../appRedux/services";
import { useForm } from "antd/lib/form/Form";

const SignIn = () => {
  const [form] = Form.useForm();
  const { isLoading, error, getUrl, setAuthUser } = useAuth();
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const history = useHistory();

  useEffect(async () => {
    await generateToken();
    if (accounts.length > 0) {
      // Obtener la cuenta actualmente autenticada (en este ejemplo, asumimos que solo hay una cuenta)
      const cuentaActual = accounts[0];
      // Obtener el oid (Object ID) de la cuenta
      const oid = cuentaActual.idTokenClaims.oid;
      // Obtener el nombre de la cuenta
      const nombre = cuentaActual.name;
      // Obtener el tid (Tenant ID) de la cuenta
      const tid = cuentaActual.tenantId;
      // Luego, puedes utilizar estos valores según tus necesidades
      console.log("OID:", oid);
      console.log("Nombre:", nombre);
      console.log("TID:", tid);
      setAuthUser({ cargo: 39842526, name: nombre, id: oid });
      localStorage.setItem("name", nombre);
      getUrl();
    } else {
      console.log("No hay cuentas autenticadas.");
    }
  }, [accounts]);

  const onFinishFailed = (errorInfo) => { };

  const onFinish = async (values) => {
    await redirectUser(values);
  };

  const redirectUser = async (formValues) => {
    try {
      const dataForm = { ...formValues };
      const isValid = await getAuthUser(dataForm);

      if (isValid) {
        history.push('/profile');
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const loginAzure = async () => {
    await settersConf();
    await Azure();
  };

  const settersConf = async () => {
    const resp = await getUrl();
    setClientId(resp.clientId);
    setRedirectUri(resp.redirectUri);
    setTenant(resp.tenantId);
    console.log(resp);
  };

  const Azure = async () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.log(e);
    });
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraph(response.accessToken).then((response) =>
          setGraphData(response)
        );
      });
  };

  return (
    <div className="login-container">
      <div className="login-intro">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="title">
          Bienvenido a Serviapoyo
        </div>
        <div className="description">
          ¡Personal confiable, éxito empresarial!
        </div>
      </div>

      <div className="login-form-wrapper">
        <div className="login-form">
          <div className="title-cs">INGRESAR A SU CUENTA</div>
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            className="form-ant"
            initialValues={{ type: 'E' }}
          >
            <Form.Item
              label="Usuario"
              name="email"
              rules={[{ required: true, message: 'El usuario es requerido' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Contraseña"
              name="password"
              rules={[{ required: true, message: 'La contraseña es requerida' }]}
            >
              <Input.Password />
            </Form.Item>
            <div className="remember-forgot-password">
              <Form.Item
                name="acceptTerms"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(new Error('Debe aceptar las políticas para continuar')),
                  },
                ]}
              >
                <Checkbox>
                  <span style={{ color: "red" }}>*</span> Aceptar los{' '}
                  <a href="https://www.impeltechnology.com/storage/servlet/Image?c=53670539&token=54263723-61110386-53675076" target="_blank" rel="noopener noreferrer">
                    Términos y Condiciones
                  </a>
                </Checkbox>
              </Form.Item>
            </div>
            <div className="remember-forgot-password">
              <Checkbox>Recordarme</Checkbox>
              <a href="/forgot-password" className="forgot-password">
                Perdió su contraseña?
              </a>
            </div>

            <Button className="submit-button" htmlType="submit">
              <strong><IntlMessages id="app.userAuth.signIn" /></strong>
            </Button>
          </Form>

          <div className="powered-by">
            <span>
              Powered by{' '}
              <a href="http://www.impeltechnology.com/portal" target="_blank" rel="noopener noreferrer">
                IMPEL
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
